// @ts-nocheck
import { name2num, num2name, } from "../../../../../../inside/(ContentTagCondition)/Comparison";
import { encodeJson as encodeJson_1, decodeJson as decodeJson_1, encodeBinary as encodeBinary_1, decodeBinary as decodeBinary_1, } from "../../../../../../inside/ContentTagValue";
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../../../../../runtime/json/scalar";
import { WireType, } from "../../../../../../../runtime/wire/index";
import { default as serialize, } from "../../../../../../../runtime/wire/serialize";
import { tsValueToWireValueFns, wireValueToTsValueFns, } from "../../../../../../../runtime/wire/scalar";
import { default as Long, } from "../../../../../../../runtime/Long";
import { default as deserialize, } from "../../../../../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        key: "",
        comparison: "UNSPECIFIED",
        value: undefined,
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.key !== undefined)
        result.key = tsValueToJsonValueFns.string(value.key);
    if (value.comparison !== undefined)
        result.comparison = tsValueToJsonValueFns.enum(value.comparison);
    if (value.value !== undefined)
        result.value = encodeJson_1(value.value);
    return result;
}
export function decodeJson(value) {
    const result = getDefaultValue();
    if (value.key !== undefined)
        result.key = jsonValueToTsValueFns.string(value.key);
    if (value.comparison !== undefined)
        result.comparison = jsonValueToTsValueFns.enum(value.comparison);
    if (value.value !== undefined)
        result.value = decodeJson_1(value.value);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.key !== undefined) {
        const tsValue = value.key;
        result.push([1, tsValueToWireValueFns.string(tsValue)]);
    }
    if (value.comparison !== undefined) {
        const tsValue = value.comparison;
        result.push([2, { type: WireType.Varint, value: new Long(name2num[tsValue]) }]);
    }
    if (value.value !== undefined) {
        const tsValue = value.value;
        result.push([3, { type: WireType.LengthDelimited, value: encodeBinary_1(tsValue) }]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.string(wireValue);
        if (value === undefined)
            break field;
        result.key = value;
    }
    field: {
        const wireValue = wireFields.get(2);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.Varint ? num2name[wireValue.value[0]] : undefined;
        if (value === undefined)
            break field;
        result.comparison = value;
    }
    field: {
        const wireValue = wireFields.get(3);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.LengthDelimited ? decodeBinary_1(wireValue.value) : undefined;
        if (value === undefined)
            break field;
        result.value = value;
    }
    return result;
}
